import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Img, { ImgProps } from "@insite/mobius/Img";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const {
        fields: { links = [] },
    } = ownProps;
    const location = getLocation(state);
    const parsedQuery = parseQueryString<{ step?: string }>(location.search);
    const step = parsedQuery.step ? parseInt(parsedQuery.step, 10) : -1;
    let currentStepData: LinkModel | null = null;
    if (step > 0 && step <= links.length) {
        currentStepData = links[step - 1];
    }

    return {
        location,
        parsedQuery,
        currentStepData,
    };
};

const enum fields {
    links = "links",
}

interface LinkModel {
    fields: {
        title: string;
        imageUrl: string;
        altText: string;
        designation: string;
    };
}

interface OwnProps extends WidgetProps {
    fields: { [fields.links]: LinkModel[] };
}
type Props = OwnProps & ReturnType<typeof mapStateToProps> & HasHistory;

export interface GaiaListingTileStyles {
    mainWrapper?: InjectableCss;
    headingWrapper?: InjectableCss;
    titleWrapper?: TypographyProps;
    gaiaListingContainer?: InjectableCss;
    cardMainWrapper?: InjectableCss;
    cardTileImage?: InjectableCss;
    cardContentWrapper?: InjectableCss;
    cardTitle?: TypographyProps;
    cardDescription?: TypographyProps;
    image?: LazyImageProps;
    img?: ImgProps;
}

export const gaiaListingTileStyles: GaiaListingTileStyles = {
    mainWrapper: {
        css: css`
            margin-left: 28px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-left: 0;
                        margin-top: 28px;
                    `,
                    css`
                        margin-left: 0;
                        margin-top: 28px;
                    `,
                    css`
                        margin-left: 0;
                        margin-top: 28px;
                    `,
                    css`
                        margin-left: 0;
                        margin-top: 28px;
                    `,
                    css``,
                ])};
        `,
    },
    headingWrapper: {
        css: css`
            padding-bottom: 10.5px;
            border-bottom: 1px solid #ccc;
            font-size: 15px;
            font-family: LatoBold;
        `,
    },
    titleWrapper: {
        css: css``,
    },
    gaiaListingContainer: {
        css: css`
            grid-gap: 30px;
            display: flex;
            margin-top: 40px;
            justify-content: flex-start;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        grid-gap: 10px;
                        justify-content: space-between;
                    `,
                    css`
                        grid-gap: 10px;
                        justify-content: space-between;
                    `,
                    css`
                        justify-content: flex-start;
                    `,
                    null,
                    null,
                ])};
        `,
    },
    cardMainWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            border: none;
            border-radius: 6px;
            margin-bottom: 0px;
            margin-right: 0px;
            > button {
                &:focus {
                    outline: none;
                }
            }
            > span {
                width: 100%;
            }
        `,
    },
    cardTileImage: {
        css: css`
            height: 50px;
            width: 137px;
            margin-bottom: 12px;

            & :focus {
                outline: none;
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        height: auto;
                        text-align: center;
                    `,
                    css`
                        width: 100%;
                        height: auto;
                        text-align: center;
                    `,
                    css`
                        margin: 0 auto 12px;
                    `,
                    css``,
                    css``,
                ])};
        `,
    },
    img: {
        css: css`
            width: 100%;
           
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        height: 100%;
                        width: 100%;
                    `,
                    css`
                        height: 100%;
                        width: 100%;
                    `,
                    css``,
                    css``,
                    css``,
                ])};
        `,
    },
    cardContentWrapper: {
        css: css`
            text-align: center;
        `,
    },
    cardTitle: {
        variant: "h2",
        color: "#333333",
        css: css`
            font-size: 16px;
            margin-bottom: 0;
            text-transform: capitalize;
            font-family: "SabonNextLTPro";
            font-weight: 600;
        `,
    },
    cardDescription: {
        color: "#333333",
        css: css`
            font-size: 14px;
            margin-bottom: 0;
            text-overflow: ellipsis;
            font-family: "Lato";
        `,
    },
};
const styles = gaiaListingTileStyles;
const GAIAListingTile: React.FC<Props> = ({ fields, history, location }) => {
    return (
        <>
            <StyledWrapper {...styles.mainWrapper}>
                <StyledWrapper {...styles.headingWrapper}>
                    <Typography {...styles.titleWrapper}>Quality Assurance Approvals</Typography>
                </StyledWrapper>
                <StyledWrapper {...styles.gaiaListingContainer}>
                    {fields.links?.map((item, index) => {
                        return (
                            <StyledWrapper {...styles.cardMainWrapper}>
                                <StyledWrapper {...styles.cardTileImage}>
                                    <Img
                                        src={item.fields.imageUrl}
                                        altText={item.fields.altText}
                                        loading="lazy"
                                        {...styles.img}
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.cardContentWrapper}>
                                    <Typography {...styles.cardTitle}>{item.fields.title}</Typography>
                                    <Typography as="p" {...styles.cardDescription}>
                                        {item.fields.designation}
                                    </Typography>
                                </StyledWrapper>
                            </StyledWrapper>
                        );
                    })}
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};
const definition: WidgetDefinition = {
    group: "Basic",
    fieldDefinitions: [
        {
            name: fields.links,
            editorTemplate: "ListField",
            defaultValue: [],
            fieldType: "General",
            getDisplay: (item: HasFields) => {
                return item.fields.title;
            },
            fieldDefinitions: [
                {
                    name: "imageUrl",
                    editorTemplate: "ImagePickerField",
                    defaultValue: "",
                },
                {
                    name: "altText",
                    editorTemplate: "TextField",
                    defaultValue: "",
                },

                {
                    name: "title",
                    displayName: "Name",
                    editorTemplate: "TextField",
                    defaultValue: "",

                    isRequired: true,
                },

                {
                    name: " designation",
                    displayName: "Designation",
                    editorTemplate: "TextField",
                    defaultValue: "",
                    isRequired: true,
                },
            ],
        },
    ],
};

const widgetModule: WidgetModule = {
    component: withHistory(connect(mapStateToProps)(GAIAListingTile)),
    definition,
};

export default widgetModule;
